import { TextComponent } from '@manifest-cyber/design-system/lib/components/TextComponent';
import { Flex, Popover, UnstyledButton } from '@mantine/core';

export const PopoverLabel = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => {
  return (
    <Popover position="top">
      <Popover.Target>
        <UnstyledButton>
          <TextComponent color="primary">{label}</TextComponent>
        </UnstyledButton>
      </Popover.Target>
      <Popover.Dropdown>
        <Flex direction="column" align="center" gap="xs">
          {children}
        </Flex>
      </Popover.Dropdown>
    </Popover>
  );
};
